import { useEffect, useRef, useState, useCallback } from "react";
import { RefreshCw } from "lucide-react";

const gen = () => String(Math.floor(100000 + Math.random() * 900000));

// Simple built-in anti-bot: user re-types a 6-digit code to prove they're human.
export function NumberChallenge({ onValidChange }) {
  const [code, setCode] = useState(gen);
  const [entry, setEntry] = useState("");
  const cbRef = useRef(onValidChange);
  cbRef.current = onValidChange;

  const refresh = useCallback(() => { setCode(gen()); setEntry(""); }, []);

  useEffect(() => { cbRef.current?.(entry === code); }, [entry, code]);

  const ok = entry === code;
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-3" data-testid="number-challenge">
      <p className="text-xs font-semibold text-slate-500">Confirm you're human — type this number:</p>
      <div className="mt-2 flex items-center gap-3">
        <span data-testid="challenge-code" className="select-none font-mono font-extrabold text-xl tracking-[0.35em] text-navy bg-white border border-slate-300 rounded-lg px-3 py-1.5 line-through decoration-slate-300/60"
          style={{ letterSpacing: "0.35em" }}>{code}</span>
        <button type="button" data-testid="challenge-refresh" onClick={refresh} title="New code"
          className="text-slate-400 hover:text-navy transition-colors"><RefreshCw className="w-4 h-4" /></button>
      </div>
      <input data-testid="challenge-input" inputMode="numeric" autoComplete="off" value={entry}
        onChange={(e) => setEntry(e.target.value.replace(/\D/g, "").slice(0, 6))}
        placeholder="Enter the 6-digit number"
        className={`mt-2 w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 ${ok ? "border-emerald-400 focus:ring-emerald-300" : "border-slate-300 focus:ring-mint"}`} />
      {entry.length === 6 && !ok && <p className="mt-1 text-xs text-red-600" data-testid="challenge-error">That doesn't match — try again.</p>}
    </div>
  );
}
